import { getFont, FONT } from '@tornado-rdk/typography';
import { FULL_HD, HD } from '@bedrock-rdk/constants';
import { makeDefaultStylingContext } from '../utils/style';

export const defaultContext = makeDefaultStylingContext();

export const getParagraphFont = screenSize => getFont(FONT.MADRID_1, screenSize);

export const getHeader1Font = screenSize => getFont(FONT.KINSHASA_3, screenSize);

export const getHeader2Font = screenSize => getFont(FONT.MADRID_3, screenSize);

export const getHeader3Font = screenSize => getFont(FONT.KINSHASA_1, screenSize);

export const PARAGRAPH_MARGIN = {
  [HD]: 24,
  [FULL_HD]: 32,
};
export const HEADER_1_MARGIN = {
  [HD]: 24,
  [FULL_HD]: 56,
};

export const HEADER_2_MARGIN = {
  [HD]: 24,
  [FULL_HD]: 32,
};

export const HEADER_3_MARGIN = {
  [HD]: 24,
  [FULL_HD]: 32,
};

export const LIST_NODE_MARGIN = {
  [HD]: 24,
  [FULL_HD]: 56,
};

export const paragraphNodeStyle = ({ screenSize } = defaultContext) => ({
  flexItem: {
    marginBottom: PARAGRAPH_MARGIN[screenSize],
  },
  text: { ...getParagraphFont(screenSize), verticalAlign: 'bottom' },
});

export const header1NodeStyle = ({ screenSize } = defaultContext) => ({
  flexItem: {
    marginBottom: HEADER_1_MARGIN[screenSize],
    alignSelf: 'center',
  },
  text: { ...getHeader1Font(screenSize), textAlign: 'center', verticalAlign: 'bottom' },
});

export const header2NodeStyle = ({ screenSize } = defaultContext) => ({
  flexItem: {
    marginBottom: HEADER_2_MARGIN[screenSize],
    alignSelf: 'center',
  },
  text: { ...getHeader2Font(screenSize), textAlign: 'center', verticalAlign: 'bottom' },
});

export const header3NodeStyle = ({ screenSize } = defaultContext) => ({
  flexItem: {
    marginBottom: HEADER_3_MARGIN[screenSize],
    alignSelf: 'center',
  },
  text: { ...getHeader3Font(screenSize), textAlign: 'center', verticalAlign: 'bottom' },
});

export const listNodeStyle = ({ screenSize } = defaultContext) => ({
  flexItem: {
    marginBottom: LIST_NODE_MARGIN[screenSize],
  },
  flex: { direction: 'column' },
});
